import React from "react";
import { useInternationalPaymentAutoSave } from "../../utils/hooks/useInternationalPaymentAutoSave";
import { InternationalPaymentFieldsInline } from "./InternationalPaymentFieldsInline";

export const InternationalPaymentFooter = () => {
  const { formValues, formMeta, isEnabled, addressData, handleChange } =
    useInternationalPaymentAutoSave();

  const visible = isEnabled && !!addressData;

  if (!isEnabled || !addressData) return null;

  return (
    <div
      style={{
        transition: "opacity 0.3s ease, transform 0.3s ease",
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(-6px)",
      }}
      className="tw-mx-10"
    >
      <InternationalPaymentFieldsInline
        formValues={formValues}
        formMeta={formMeta}
        onChange={handleChange}
      />
    </div>
  );
};
